import { Flex, Text, Title } from "@mantine/core";
import { IListProduct } from "../../../../interfaces/Products/IListProducts";

interface IProps {
  item: IListProduct;
}

export default function HeaderNewCardSpider({ item }: IProps) {
  return (
    <Flex gap="2px" w="100%" direction={"column"}>
      <Text
        transform="uppercase"
        fw={500}
        size={14}
        lh={"22px"}
        color="basic.1"
        ff="Barlow"
        style={{
          whiteSpace: "nowrap",
        }}
      >
        {!!item?.partner ? item.partner : "--"}
      </Text>
      <Title
        transform="uppercase"
        fw={700}
        fz={{ base: 16, 991: 19 }}
        color="other.0"
      >
        {!!item?.title ? item.title : "--"}
      </Title>
      <Text
        transform="uppercase"
        fw={500}
        size={14}
        lh={"22px"}
        color="basic.1"
        ff="Barlow"
        style={{
          whiteSpace: "nowrap",
        }}
      >
        {!!item?.subcategory ? item.subcategory : "--"}
      </Text>
    </Flex>
  );
}
